// admin/src/lib/storagePaths.ts
//
// Object paths in the public `exercise-media` bucket (migration
// 0025_media_library.sql): `equipment/<id>/<random>.<ext>`,
// `exercises/<exercise_id>/<random>.<ext>`, `slots/<slot>/<random>.<ext>`.
// Random (not content-derived) names so a replace never reuses a stale
// CDN-cached URL.

function randomToken(len = 16): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  // crypto.getRandomValues is available in every browser this admin ships to.
  const bytes = new Uint8Array(len);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < len; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  let out = '';
  for (let i = 0; i < len; i++) out += chars[bytes[i] % chars.length];
  return out;
}

export function equipmentPhotoPath(equipmentId: string, ext: string = 'jpg'): string {
  return `equipment/${equipmentId}/${randomToken()}.${ext.replace(/^\./, '')}`;
}

export function exerciseMediaPath(exerciseId: string, ext: string): string {
  return `exercises/${exerciseId}/${randomToken()}.${ext.replace(/^\./, '')}`;
}

export function mediaSlotPath(slot: string, ext: string = 'jpg'): string {
  return `slots/${slot}/${randomToken()}.${ext.replace(/^\./, '')}`;
}

/** The file extension (no dot, lowercased) a File's name or MIME type implies. */
export function extensionFor(file: { name?: string; type?: string }): string {
  const parts = file.name?.split('.') ?? [];
  const fromName = parts.length > 1 ? parts.pop()?.toLowerCase() : undefined;
  if (fromName && /^[a-z0-9]{2,5}$/.test(fromName)) return fromName;
  const mime = file.type || '';
  if (mime === 'image/jpeg') return 'jpg';
  if (mime === 'image/png') return 'png';
  if (mime === 'image/webp') return 'webp';
  if (mime === 'video/mp4') return 'mp4';
  if (mime === 'video/quicktime') return 'mov';
  return 'bin';
}

/** `<SUPABASE_URL>/storage/v1/object/public/exercise-media/<path>`, or null when there's no path. */
export function publicMediaUrl(supabaseUrl: string, path: string | null | undefined): string | null {
  if (!path) return null;
  const base = supabaseUrl.replace(/\/$/, '');
  return `${base}/storage/v1/object/public/exercise-media/${path}`;
}
